
// // src/components/charting/ImageViewer.tsx
// import React, { useState } from "react";
// import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
// import "../../css/ImageViewer.css";

// interface ImageViewerProps {
//   imageSrc: string;
// }

// const ImageViewer: React.FC<ImageViewerProps> = ({ imageSrc }) => {
//   const [isPanEnabled, setIsPanEnabled] = useState(false);

//   return (
//     <div className="image-display-area">
//       <TransformWrapper
//         key={imageSrc || "empty"}
//         panning={{ disabled: !isPanEnabled }}
//         doubleClick={{ disabled: true }}
//       >
//         {({ zoomIn, zoomOut, resetTransform }) => (
//           <>
//             <div className="image-tools">
              
//               <button onClick={() => resetTransform()}>🔄</button>
//               <button onClick={() => zoomIn()}>➕</button>
//               <button onClick={() => zoomOut()}>➖</button>

//               <button
//                 className={isPanEnabled ? "pan-active" : ""}
//                 title={isPanEnabled ? "Pan Tool (ON)" : "Pan Tool (OFF)"}
//                 onClick={() => setIsPanEnabled((v) => !v)}
//                 aria-pressed={isPanEnabled}
//               >
//                 ✋
//               </button>
//             </div>

//             <TransformComponent
//               wrapperClass="image-transform-wrapper"
//               contentClass={`image-transform-content ${
//                 isPanEnabled ? "pan-enabled" : ""
//               }`}
//             >
//               {imageSrc ? (
//                 <img
//                   key={imageSrc}
//                   src={imageSrc}
//                   alt="Dental view"
//                   className="dental-image"
//                   draggable={false}
//                 />
//               ) : (
//                 <div className="image-placeholder" />
//               )}
//             </TransformComponent>
//           </>
//         )}
//       </TransformWrapper>
//     </div>
//   );
// };

// export default ImageViewer;





import React, { useState } from "react";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import "../../css/ImageViewer.css";

interface ImageViewerProps {
  imageSrc: string;
}

const ImageViewer: React.FC<ImageViewerProps> = ({ imageSrc }) => {
  const [isPanEnabled, setIsPanEnabled] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      {/* ===== NORMAL VIEW ===== */}
      <div className="image-display-area">
        <TransformWrapper
          key={imageSrc || "empty"}
          panning={{ disabled: !isPanEnabled }}
          doubleClick={{ disabled: true }}
          wheel={{ disabled: false }} // ✅ enable wheel zoom
        >
          {({ zoomIn, zoomOut, resetTransform }) => (
            <>
              <div className="image-tools">
                <button onClick={() => resetTransform()}>🔄</button>
                <button onClick={() => zoomIn()}>➕</button>
                <button onClick={() => zoomOut()}>➖</button>

                <button
                  className={isPanEnabled ? "pan-active" : ""}
                  onClick={() => setIsPanEnabled((v) => !v)}
                >
                  ✋
                </button>
              </div>

              {/* 🔥 CLICK WRAPPER FIX */}
              <div onClick={() => setIsModalOpen(true)}>
                <TransformComponent
                  wrapperClass="image-transform-wrapper"
                  contentClass={`image-transform-content ${
                    isPanEnabled ? "pan-enabled" : ""
                  }`}
                >
                  {imageSrc ? (
                    <img
                      src={imageSrc}
                      alt="Dental view"
                      className="dental-image"
                      draggable={false}
                    />
                  ) : (
                    <div className="image-placeholder" />
                  )}
                </TransformComponent>
              </div>
            </>
          )}
        </TransformWrapper>
      </div>

      {/* ===== MODAL ===== */}
   {isModalOpen && (
  <div className="image-modal-overlay">
    <div className="image-modal-content">
      {/* ❌ CLOSE BUTTON */}
      <button
        className="modal-close-btn"
        onClick={() => setIsModalOpen(false)}
      >
        ✖
      </button>

      <TransformWrapper
        wheel={{ disabled: false }}
        doubleClick={{ disabled: false }}
      >
        {({ zoomIn, zoomOut, resetTransform }) => (
          <>
            <div className="modal-tools">
              <button onClick={() => resetTransform()}>🔄</button>
              <button onClick={() => zoomIn()}>➕</button>
              <button onClick={() => zoomOut()}>➖</button>
            </div>

            <TransformComponent>
              <img
                src={imageSrc}
                alt="Zoomed Dental"
                className="modal-image"
              />
            </TransformComponent>
          </>
        )}
      </TransformWrapper>
    </div>
  </div>
)}
    </>
  );
};

export default ImageViewer;